import moment from 'moment';
import {StudentReport, StatisticByStudent} from './types/NewStudentReportTypes';

/**
 * Default student report with zero values
 * Used when API returns no data - mirrors ClassReport pattern
 */
export const createDefaultStudentReport = (studentId: string): StudentReport => ({
  _id: 'default-student-report',
  studentId: studentId,
  month: moment().format('YYYY-MM-DD'),
  isCompleted: false,
  totalDaysInMonth: moment().daysInMonth(),

  // All zeros
  absenceDays: 0,
  activeDaysInMonth: 0,
  attempts: 0,
  attendanceRate: 0,
  cumulativeRankInClass: 0,
  average: 0,
  improvementRate: 0,
  mistakes: 0,
  monthlyPerformance: 0,
  monthlyRankInClass: 0,
  numberOfStudentsInClass: 0,
  successfullQuestions: 0,
  totalScores: 0,
  dailyPerformances: [],
});

export const createDefaultStatisticByStudent = (
  studentId: string,
): StatisticByStudent => ({
  id: 'default-statistic',
  averageScore: 0,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  phonetics: [],
  syllables: [],
  scores: [],
  student: {id: studentId, name: ''},
});
